import { RefObject, useEffect } from "react";

import { usePlayerControls2 } from "./PlayerControlsContext";

type UsePlayerKeyboardControlsProps = {
  togglePlay: () => void;
  toggleMute: () => void;
  setVolumeLevel: (volume: number) => void;
  seek: (time: number) => void;
  toggleFullScreen: () => void;
  volume: number;
  isMuted: boolean;
  videoRef: RefObject<HTMLVideoElement>;
};

export const usePlayerKeyboardControls = ({
  togglePlay,
  toggleMute,
  setVolumeLevel,
  seek,
  toggleFullScreen,
  volume,
  isMuted,
  videoRef,
}: UsePlayerKeyboardControlsProps) => {
  const { seek: tempSeek } = usePlayerControls2();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      switch (event.key) {
        case " ":
          event.preventDefault();
          togglePlay();
          break;
        case "ArrowRight":
          if (event.repeat) {
            tempSeek(videoRef, 20);
          } else {
            seek(10);
          }
          break;
        case "ArrowLeft":
          if (event.repeat) {
            tempSeek(videoRef, -20);
          } else {
            seek(-10);
          }
          break;
        case "ArrowUp":
          setVolumeLevel(Math.min(volume + 0.1, 1));
          if (isMuted) toggleMute();
          break;
        case "ArrowDown":
          setVolumeLevel(Math.max(volume - 0.1, 0));
          break;
        case "m":
        case "M":
          toggleMute();
          break;
        case "w":
        case "W":
          toggleFullScreen();
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [togglePlay, seek, toggleMute, toggleFullScreen, setVolumeLevel, volume, isMuted, tempSeek, videoRef]);
};
